<template>
  <div class="oneTrust">
    <div :id="dataDivId" class="otnotice"></div>
  </div>
</template>

<script>
export default {
  name: 'OneTrust',
  props: {
    dataDivId: { type: String, required: true },
    dataSettings: { type: String, required: true },
    dataOneTrustCdn: { type: String, required: true },
    dataNotices: { type: String, required: true },
    dataCookiePolicyUrl: { type: String, default: '#' },
  },
  computed: {
    notices() {
      let allnotices = '[';
      this.dataNotices.split(',').forEach((notice) => {
        allnotices === '['
          ? (allnotices = allnotices + '"' + notice + '"')
          : (allnotices = allnotices + ',"' + notice + '"');
      });
      return allnotices + ']';
    },
  },
  created() {
    // first script
    let scriptTag = document.createElement('script');
    scriptTag.innerHTML = 'settings=' + this.dataSettings;
    scriptTag.setAttribute('src', this.dataOneTrustCdn);
    scriptTag.setAttribute('id', 'otprivacy-notice-script');
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.setAttribute('charset', 'UTF-8');

    this.$nextTick(() => {
      document.body.appendChild(scriptTag);
      window.expCounter = 0;
      (() => {
        const doCheck = () => {
          if (window.OneTrust && window.OneTrust.NoticeApi) {
            // Called directly: an injected inline <script> would be blocked by the CSP.
            window.OneTrust.NoticeApi.Initialized.then(() => {
              window.OneTrust.NoticeApi.LoadNotices(JSON.parse(this.notices));
            });
          } else {
            window.expCounter++;
            if (window.expCounter !== 10) {
              setTimeout(doCheck, Math.exp(window.expCounter));
            }
          }
        };
        doCheck();
      })();
    });
  },
  mounted() {
    (() => {
      const doCheck = () => {
        const cookieLinks = Array.prototype.slice.call(
          document.querySelectorAll('a[id="onetrust-cookie-link"]')
        );

        for (
          var i = 0, cookieLink = cookieLinks[i];
          i < cookieLinks.length;
          cookieLink = cookieLinks[++i]
        ) {
          if ('getAttribute' in cookieLink) {
            const isAlreadyParsed = cookieLink.getAttribute('data-parsed');
            if (!isAlreadyParsed) {
              cookieLink.setAttribute('data-parsed', true);
              cookieLink.setAttribute('href', this.dataCookiePolicyUrl);
            }
          }
        }
        this.count++;
        if (this.count !== 10) {
          setTimeout(doCheck, Math.exp(this.count));
        }
      };
      doCheck();
    })();
    (() => {
      const doCheck = () => {
        const menuInternalLinks = Array.prototype.slice.call(
          document.querySelectorAll('a[href^="#otnotice-section"]')
        );

        for (
          var i = 0, menuInternalLink = menuInternalLinks[i];
          i < menuInternalLinks.length;
          menuInternalLink = menuInternalLinks[++i]
        ) {
          if ('getAttribute' in menuInternalLink) {
            const isAlreadyParsed =
              menuInternalLink.getAttribute('data-parsed');
            const originalAnchor = menuInternalLink.getAttribute('href');
            if (!isAlreadyParsed) {
              menuInternalLink.setAttribute('data-parsed', true);
              menuInternalLink.setAttribute(
                'href',
                `${window.location.origin}${window.location.pathname}${originalAnchor}`
              );
            }
          }
        }
        this.count++;
        if (this.count !== 10) {
          setTimeout(doCheck, Math.exp(this.count));
        }
      };
      doCheck();
    })();
  },
};
</script>
